import { ActionLink } from "@diffex/ui";

import { PublicLayout } from "../components/PublicLayout";
import { productConfig } from "../config";

export function SignedOutPage() {
  return (
    <PublicLayout>
      <p className="eyebrow">Signed out</p>
      <h1>You are signed out</h1>
      <p>Your Diffex session has ended on this device.</p>
      <div className="public-actions">
        <ActionLink href="/login?return_to=/">Sign in again</ActionLink>
        <ActionLink href={productConfig.marketingOrigin} tone="secondary">
          Return to Diffex
        </ActionLink>
      </div>
    </PublicLayout>
  );
}
